import * as React from "react";
import {useContext} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilValue, useSetRecoilState} from "recoil";
import * as Yup from "yup";
import AdvancedFilter from "../../../component/AdvancedFilter";
import {addFilter, getFilterValue, renderSelect} from "../../../utils/FilterUtils";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {
    ID_FILTER_DEALER,
    ID_FILTER_LEGAL_ENTITY,
    STATE_REFUELLING_ACTIVE_FILTERS
} from "../constants/ConstantsRefuelling";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

function RefuellingFilters() {
    const {t: tg} = useTranslation("translation");
    const {
        globalData: {user},
    } = useContext(GlobalContext);

    const legalEntityOptions: any[] = user.legalEntities
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => ({
            value: x.name,
            label: tg(`legalEntities.${x.name}`),
        }));

    const dealerOptions: any[] = user.dealers
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => ({
            value: x.name,
            label: tg(`dealers.${x.name}`),
        }));

    const [dealers, setDealers] = React.useState<any[]>(dealerOptions);
    const setFilters = useSetRecoilState(STATE_REFUELLING_ACTIVE_FILTERS);
    const filterDefs = useRecoilValue(STATE_REFUELLING_ACTIVE_FILTERS);

    const schema = Yup.object().shape({
        legalEntity: Yup.string().required(),
        dealer: Yup.string()
    });

    const defaultValues = {
        legalEntity:  getFilterValue(ID_FILTER_LEGAL_ENTITY, filterDefs) || legalEntityOptions[0].value,
        dealer: getFilterValue(ID_FILTER_DEALER, filterDefs) || dealerOptions.length == 1 ? dealerOptions[0].value : "",
    };

    const handleChangeLegalEntities = (value: any) => {
        if (value == '') {
            setDealers([]);
            return;
        }
        let dealers = user?.dealers
            ?.filter(
                (x: any) =>
                    x.legalEntities.some((e: any) => value == e.name) &&
                    x.name.toLowerCase() !== "all"
            )
            .map((x: any) => {
                return {
                    label: tg(`dealers.${x.name}`),
                    value: x.name,
                };
            });
        setDealers(dealers);
    }

    const renderSelectLegalEntity =
        (name: string, label: string, items: any[] ) => (field: any) =>
            (
                <TextField
                    name={name}
                    fullWidth
                    select
                    label={label}
                    value={field.value}
                    onChange={(e:any) => {
                        handleChangeLegalEntities(e.target.value)
                        field.onChange(e)
                    }}
                >
                    {items.map((option: any) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            );

    const mainFields = {
        legalEntity: renderSelectLegalEntity(
            ID_FILTER_LEGAL_ENTITY,
            tg("shared.legalEntity"),
            legalEntityOptions
        ),
        dealer: renderSelect(
            ID_FILTER_DEALER,
            tg("shared.dealers"),
            dealers
        ),
    };

    const submit = (data: any) => {
        addFilter(setFilters, ID_FILTER_LEGAL_ENTITY, data.legalEntity);
        addFilter(setFilters, ID_FILTER_DEALER, data.dealer);
    };

    const reset = () => {
        setFilters([]);
        setDealers(dealerOptions)
    };

    return (
        <AdvancedFilter
            schema={schema}
            mainFields={mainFields}
            defaultValues={defaultValues}
            onSubmit={submit}
            onReset={reset}
        />
    );
}


export default RefuellingFilters;